export type FutureMedicalMetadocSection =
  | "msa"
  | "amended-review"
  | "mcp"
  | "lcp"
  | "ar-screening";

export type MetadocRouteParams = {
  fileId?: string;
  documentManagementFileId?: string;
  msaId?: string;
  mcpId?: string;
  lcpId?: string;
  reviewId?: string;
};

export type MetadocNavigationContext =
  | {
      workspace: "operations";
      fileId: number | string;
    }
  | {
      workspace: "document-management";
      documentManagementFileId: number | string;
      fileId?: number | string;
    }
  | {
      workspace: "future-medical";
      serviceSection: FutureMedicalMetadocSection;
      serviceId: number | string;
      fileId?: number | string;
    };

export const getFutureMedicalMetadocContext = (
  pathname: string,
  params: MetadocRouteParams,
): MetadocNavigationContext | null => {
  if (pathname.includes("/future-medical/msa/") && params.msaId) {
    return {
      workspace: "future-medical",
      serviceSection: "msa",
      serviceId: params.msaId,
    };
  }

  if (pathname.includes("/future-medical/amended-review/") && params.msaId) {
    return {
      workspace: "future-medical",
      serviceSection: "amended-review",
      serviceId: params.msaId,
    };
  }

  if (pathname.includes("/future-medical/mcp/") && params.mcpId) {
    return {
      workspace: "future-medical",
      serviceSection: "mcp",
      serviceId: params.mcpId,
    };
  }

  if (pathname.includes("/future-medical/lcp/") && params.lcpId) {
    return {
      workspace: "future-medical",
      serviceSection: "lcp",
      serviceId: params.lcpId,
    };
  }

  if (pathname.includes("/future-medical/ar-screening/") && params.reviewId) {
    return {
      workspace: "future-medical",
      serviceSection: "ar-screening",
      serviceId: params.reviewId,
    };
  }

  return null;
};

export const getMetadocNavigationContext = (
  pathname: string,
  params: MetadocRouteParams,
): MetadocNavigationContext | null => {
  const futureMedicalContext = getFutureMedicalMetadocContext(pathname, params);

  if (futureMedicalContext) {
    return futureMedicalContext;
  }

  if (pathname.includes("/operations/files/") && params.fileId) {
    return {
      workspace: "operations",
      fileId: params.fileId,
    };
  }

  if (
    pathname.includes("/document-management/") &&
    params.documentManagementFileId
  ) {
    return {
      workspace: "document-management",
      documentManagementFileId: params.documentManagementFileId,
    };
  }

  return null;
};

export const buildMetadocPath = (
  context: MetadocNavigationContext,
  metadocId?: number | string,
) => {
  if (context.workspace === "future-medical") {
    const basePath = `/future-medical/${context.serviceSection}/${context.serviceId}/metadoc`;

    return metadocId ? `${basePath}/${metadocId}` : basePath;
  }

  if (context.workspace === "document-management") {
    const basePath = `/document-management/${context.documentManagementFileId}/metadoc`;

    return metadocId ? `${basePath}/${metadocId}` : basePath;
  }

  const basePath = `/operations/files/${context.fileId}/metadoc`;

  return metadocId ? `${basePath}/${metadocId}` : basePath;
};
